import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminImport = (args) => {
    return useQuery({
        queryKey: ['admin', 'import', 'list', args],
        queryFn: () => (((config) => {
            return generalRequest.get(`/admin/imports`, {params: config})
        })(args)),
    })
}


export function useApiAminCreateImport() {
    return useMutation({
        mutationFn: (data) =>
            (((data) => {
                return generalRequest.post(`/admin/imports`, data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },

                })
            })(data))
    });
}
